/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: block;
}

.qds-titles {
  display: grid;
  grid-template-areas:
    'kicker'
    'title'
    'subtitle';
}

.qds-has-icon {
  grid-template-areas:
    '.    kicker'
    'icon title'
    '.    subtitle';
}

.qds-title,
.qds-subtitle,
.qds-kicker {
  margin-block: 0;
}

.qds-title {
  grid-area: title;
  color: var(--qds-theme-title);
}

.qds-subtitle {
  grid-area: subtitle;
  color: var(--qds-theme-subtitle);
}

.qds-kicker {
  grid-area: kicker;
  color: var(--qds-theme-kicker);
}

.qds-icon {
  grid-area: icon;
}

.qds-main {
  &.qds-section {
    &.qds-titles {
      gap: var(--qds-main-section-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-main-section-titles-gap)
        var(--qds-main-section-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-main-section-title);
    }

    & .qds-subtitle {
      font: var(--qds-main-section-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-main-section-kicker);
    }

    & .qds-icon {
      width: var(--qds-main-section-titles-icon-size);
      height: var(--qds-main-section-titles-icon-crop-height);
    }
  }

  &.qds-subsection {
    &.qds-titles {
      gap: var(--qds-main-subsection-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-main-subsection-titles-gap)
        var(--qds-main-subsection-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-main-subsection-title);
    }

    & .qds-subtitle {
      font: var(--qds-main-subsection-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-main-subsection-kicker);
    }

    & .qds-icon {
      width: var(--qds-main-subsection-titles-icon-size);
      height: var(--qds-main-subsection-titles-icon-crop-height);
    }
  }
}

.qds-panel {
  &.qds-root {
    &.qds-titles {
      gap: var(--qds-panel-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-panel-titles-gap) var(--qds-panel-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-panel-title);
    }

    & .qds-subtitle {
      font: var(--qds-panel-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-panel-kicker);
    }

    & .qds-icon {
      width: var(--qds-panel-titles-icon-size);
      height: var(--qds-panel-titles-icon-crop-height);
    }
  }

  &.qds-section {
    &.qds-titles {
      gap: var(--qds-panel-section-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-panel-section-titles-gap)
        var(--qds-panel-section-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-panel-section-title);
    }

    & .qds-subtitle {
      font: var(--qds-panel-section-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-panel-section-kicker);
    }

    & .qds-icon {
      width: var(--qds-panel-section-titles-icon-size);
      height: var(--qds-panel-section-titles-icon-crop-height);
    }
  }

  &.qds-subsection {
    &.qds-titles {
      gap: var(--qds-panel-subsection-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-panel-subsection-titles-gap)
        var(--qds-panel-subsection-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-panel-subsection-title);
    }

    & .qds-subtitle {
      font: var(--qds-panel-subsection-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-panel-subsection-kicker);
    }

    & .qds-icon {
      width: var(--qds-panel-subsection-titles-icon-size);
      height: var(--qds-panel-subsection-titles-icon-crop-height);
    }
  }
}

.qds-navigation {
  &.qds-section {
    &.qds-titles {
      gap: var(--qds-navigation-section-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-navigation-section-titles-gap)
        var(--qds-navigation-section-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-navigation-section-title);
    }

    & .qds-subtitle {
      font: var(--qds-navigation-section-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-navigation-section-kicker);
    }

    & .qds-icon {
      width: var(--qds-navigation-section-titles-icon-size);
      height: var(--qds-navigation-section-titles-icon-crop-height);
    }
  }

  &.qds-subsection {
    &.qds-titles {
      gap: var(--qds-navigation-subsection-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-navigation-subsection-titles-gap)
        var(--qds-navigation-subsection-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-navigation-subsection-title);
    }

    & .qds-subtitle {
      font: var(--qds-navigation-subsection-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-navigation-subsection-kicker);
    }

    & .qds-icon {
      width: var(--qds-navigation-subsection-titles-icon-size);
      height: var(--qds-navigation-subsection-titles-icon-crop-height);
    }
  }
}

.qds-popup {
  &.qds-root {
    &.qds-titles {
      gap: var(--qds-popup-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-popup-titles-gap) var(--qds-popup-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-popup-title);
    }

    & .qds-subtitle {
      font: var(--qds-popup-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-popup-kicker);
    }

    & .qds-icon {
      width: var(--qds-popup-titles-icon-size);
      height: var(--qds-popup-titles-icon-crop-height);
    }
  }

  &.qds-section {
    &.qds-titles {
      gap: var(--qds-popup-section-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-popup-section-titles-gap)
        var(--qds-popup-section-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-popup-section-title);
    }

    & .qds-subtitle {
      font: var(--qds-popup-section-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-popup-section-kicker);
    }

    & .qds-icon {
      width: var(--qds-popup-section-titles-icon-size);
      height: var(--qds-popup-section-titles-icon-crop-height);
    }
  }

  &.qds-subsection {
    &.qds-titles {
      gap: var(--qds-popup-subsection-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-popup-subsection-titles-gap)
        var(--qds-popup-subsection-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-popup-subsection-title);
    }

    & .qds-subtitle {
      font: var(--qds-popup-subsection-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-popup-subsection-kicker);
    }

    & .qds-icon {
      width: var(--qds-popup-subsection-titles-icon-size);
      height: var(--qds-popup-subsection-titles-icon-crop-height);
    }
  }
}

.qds-accessory {
  &.qds-root {
    &.qds-titles {
      gap: var(--qds-accessory-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-accessory-titles-gap) var(--qds-accessory-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-accessory-title);
    }

    & .qds-subtitle {
      font: var(--qds-accessory-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-accessory-kicker);
    }

    & .qds-icon {
      width: var(--qds-accessory-titles-icon-size);
      height: var(--qds-accessory-titles-icon-crop-height);
    }
  }

  &.qds-section {
    &.qds-titles {
      gap: var(--qds-accessory-section-titles-gap);
    }

    &.qds-has-icon {
      gap: var(--qds-accessory-section-titles-gap)
        var(--qds-accessory-section-titles-icon-gap);
    }

    & .qds-title {
      font: var(--qds-accessory-section-title);
    }

    & .qds-subtitle {
      font: var(--qds-accessory-section-subtitle);
    }

    & .qds-kicker {
      font: var(--qds-accessory-section-kicker);
    }

    & .qds-icon {
      width: var(--qds-accessory-section-titles-icon-size);
      height: var(--qds-accessory-section-titles-icon-crop-height);
    }
  }
}
